/**
 * Embed para Alta promoción (Marco): reutiliza FichaResumenPanel.
 * El mockup HTML abre un iframe a esta ruta y envía los datos por postMessage.
 */
import { useEffect, useState, useCallback } from "react";
import FichaResumenPanel from "../components/propiedades/FichaResumenPanel";
import { mapearUnidadPromocionAFichaResumen } from "../components/propiedades/mapearUnidadPromocionAFichaResumen";

const MSG_READY = "vc-ficha-resumen-ready";
const MSG_DATOS = "vc-ficha-resumen-datos";
const MSG_CLOSE = "vc-ficha-resumen-close";

export default function EmbedVistaPreviaPromocion() {
  const [pack, setPack] = useState(null);
  const [error, setError] = useState(null);

  const cerrar = useCallback(() => {
    try {
      window.parent?.postMessage({ type: MSG_CLOSE }, "*");
    } catch {
      /* */
    }
  }, []);

  useEffect(() => {
    document.documentElement.style.background = "transparent";
    document.body.style.background = "transparent";
    document.body.style.margin = "0";
    document.body.style.overflow = "hidden";
  }, []);

  useEffect(() => {
    const onMsg = (ev) => {
      const data = ev?.data;
      if (!data || typeof data !== "object") return;
      if (data.type !== MSG_DATOS) return;
      try {
        const payload = data.payload || {};
        const mapped = mapearUnidadPromocionAFichaResumen(payload.unidad, {
          datos: payload.datos,
          form: payload.form,
          fotos: payload.fotos,
          archivosNombres: payload.archivosNombres,
        });
        setPack(mapped);
        setError(null);
      } catch (e) {
        console.error(e);
        setError(e?.message || "Error al mapear ficha");
        setPack(null);
      }
    };
    window.addEventListener("message", onMsg);
    try {
      window.parent?.postMessage({ type: MSG_READY }, "*");
    } catch {
      /* */
    }
    return () => window.removeEventListener("message", onMsg);
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") cerrar();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [cerrar]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black/40 text-white text-sm p-6">
        {error}
        <button type="button" className="ml-4 underline" onClick={cerrar}>
          Cerrar
        </button>
      </div>
    );
  }

  if (!pack) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black/40 text-slate-300 text-sm">
        Cargando vista previa…
      </div>
    );
  }

  return <FichaResumenPanel p={pack.p} d={pack.d} onClose={cerrar} />;
}
